import { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import type { Campaign } from "../../../types/campaign";
import { getApiErrorMessage } from "../../../utils";

export default function CampaignDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [campaign, setCampaign] = useState<Campaign>();
  const [error, setError] = useState("");
  useEffect(() => {
    api
      .get<Campaign>(`/campaigns/${id}`)
      .then((response) => setCampaign(response.data))
      .catch((err) => setError(getApiErrorMessage(err)));
  }, [id]);
  if (error)
    return (
      <div role="alert" className="m-6 rounded bg-red-50 p-5 text-red-700">
        {error}
      </div>
    );
  if (!campaign) return <div className="p-6">Carregando campanha...</div>;
  return (
    <section className="mx-auto max-w-4xl space-y-5 p-3 sm:p-6">
      <button
        className="flex items-center gap-1 text-sm text-blue-700"
        onClick={() => navigate("/painel/comercial/campanhas")}
      >
        <ArrowLeft size={16} /> Campanhas
      </button>
      <div className="rounded-xl border bg-white p-6 shadow-sm">
        <h1 className="text-2xl font-bold">{campaign.name}</h1>
        <p className="mt-1 text-slate-600">Status: {campaign.status}</p>
        <div className="mt-6 grid gap-4 sm:grid-cols-3">
          <div className="rounded-lg bg-slate-50 p-4">
            <span className="text-xs text-slate-500">Destinatários</span>
            <strong className="block text-xl">
              {campaign.total_recipients}
            </strong>
          </div>
          <div className="rounded-lg bg-slate-50 p-4">
            <span className="text-xs text-slate-500">Processados</span>
            <strong className="block text-xl">
              {campaign.processed_recipients}
            </strong>
          </div>
          <div className="rounded-lg bg-slate-50 p-4">
            <span className="text-xs text-slate-500">Enviados</span>
            <strong className="block text-xl">
              {campaign.sent_recipients}
            </strong>
          </div>
        </div>
        <h2 className="mt-6 font-semibold">Template</h2>
        <p className="text-sm text-slate-600">
          {campaign.template?.name || "Ainda não selecionado"}
        </p>
        {campaign.template && (
          <div className="mt-3 whitespace-pre-wrap rounded-lg bg-emerald-50 p-4 text-sm">
            {campaign.template.text}
          </div>
        )}
        <div className="mt-5 text-sm text-slate-600">
          Ignorados: {campaign.skipped_recipients} · Falhas:{" "}
          {campaign.failed_recipients}
        </div>
      </div>
    </section>
  );
}
